import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import AllRoutes from "./routes";

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <AllRoutes />
  </BrowserRouter>
);
